import { render } from "./OfferingSingle.vue?vue&type=template&id=c10a55f4&scoped=true"
import script from "./OfferingSingle.vue?vue&type=script&lang=js"
export * from "./OfferingSingle.vue?vue&type=script&lang=js"

import "./OfferingSingle.vue?vue&type=style&index=0&id=c10a55f4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c10a55f4"

export default script